import { Component } from 'opus-angular-seed-core';
import template from './template.html';

/**
 * Menu of an item of the chapter list, the menu items are transcluded.
 */
@Component({
    transclude: true,
    bindings: {
        isOpen: '<',
        onToggle: '&'
    },
    template
})
export default class {
    constructor ($element, $timeout) {
        this.$element = $element;
        this.$timeout = $timeout;
    }

    toggle () {
        this.onToggle();
        this.openUpwardsWhenNeeded();
    }

    /**
     * The menu opens downwards by default, which hides it when the item is near the bottom of the
     * window. In that case the menu is flipped above the button.
     */
    openUpwardsWhenNeeded () {
        const menu = this.$element[0];
        menu.classList.remove('open-up');

        this.$timeout(() => {
            const list = menu.querySelector('UL');
            if (!list) {
                return;
            }

            const listRect = list.getBoundingClientRect();
            const buttonRect = menu.getBoundingClientRect();
            const spaceBelow = window.innerHeight - buttonRect.bottom;

            if (listRect.height > spaceBelow && buttonRect.top > listRect.height) {
                menu.classList.add('open-up');
            }
        }, 0, false);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/authoringTool/editor/actionMenu/index.js